module.exports = __webpack_public_path__ + "img/empty-community-group.e7d44d5b.svg";